import { Typography, Box, useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// Component for Variables content
const VariablesOverview = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box style={{
            display: 'flex', flexDirection: 'column', gap: '16px', flex: 1, overflowY: 'auto',
            p: 3
        }}>

            <Typography
                variant="body1"
                style={{ width: isMediumScreen ? '100%' : '60%' }}
            >
                <strong>Variables Overview</strong>
                <br /><br />
                <p>
                    Variables in <strong>HawkClient</strong> are powerful placeholders that let you
                    define dynamic, reusable values to simplify request building and workspace management.
                    They help you avoid hardcoding values like API endpoints, tokens, or user IDs, and
                    allow smoother transitions between environments.
                </p>

                <p>
                    HawkClient supports four types of variables, each with its own scope and purpose:
                </p>

                <ul style={{ paddingLeft: '20px' }}>
                    <li>
                        <strong>Global Variables</strong> – Available across the entire workspace, including all collections and requests. Best used for constants or fallback values.
                    </li>
                    <li>
                        <strong>Collection Variables</strong> – Scoped to a specific collection and available to all requests within it. Useful for collection-level settings like authentication tokens or API versions.
                    </li>
                    <li>
                        <strong>Environment Variables</strong> – Workspace-level variables grouped into environments (e.g., dev, staging, prod). Ideal for managing differences in base URLs, tokens, etc., across different deployment environments.
                    </li>
                    <li>
                        <strong>Request Variables</strong> – Defined per request. These have the highest precedence and are useful for temporary values or for setting data dynamically using pre-request or post-response scripts.
                    </li>
                </ul>

                <p>
                    You can use any variable by wrapping its name in double curly braces, like
                    <code>{` {{baseUrl}} `}</code>.
                </p>

                <p>
                    <strong>Variable Precedence</strong> determines which variable is used when multiple variables
                    share the same name across different scopes. HawkClient resolves variables in the following order:
                </p>

                <ol style={{ paddingLeft: '20px' }}>
                    <li><strong>Request Variables</strong> – highest priority</li>
                    <li><strong>Environment Variables</strong></li>
                    <li><strong>Collection Variables</strong></li>
                    <li><strong>Global Variables</strong> – lowest priority</li>
                </ol>

                <p>
                    This means if a variable named <code>token</code> exists in both request and environment scopes,
                    the request-level value will be used.
                </p>

                <p>
                    Variables are stored as JSON files within your workspace folder, making them easy to version
                    control and share across teams.
                </p>
            </Typography>
        </Box>
    )
};

export default VariablesOverview;